(() => {
  if (window.nativeRecentlyViewedReady) return;
  window.nativeRecentlyViewedReady = true;

  function initialize(section) {
    const list = section.querySelector('.recently-viewed-products-placeholder .product-list');
    if (!list || list.dataset.nativeRecentReady === 'true') return;
    list.dataset.nativeRecentReady = 'true';
    const controls = section.querySelector('[data-native-recent-controls]');
    const previous = section.querySelector('[data-native-recent-previous]');
    const next = section.querySelector('[data-native-recent-next]');
    const update = () => {
      const items = list.querySelectorAll('.native-recently-viewed__item');
      if (!items.length) return;
      list.style.setProperty('--native-recent-columns', Math.min(items.length, 4));
      const viewport = list.getBoundingClientRect();
      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(list).direction === 'rtl';
      const atStart = rtl ? first.right <= viewport.right + 6 : first.left >= viewport.left - 6;
      const atEnd = rtl ? last.left >= viewport.left - 6 : last.right <= viewport.right + 6;
      const focusedPrevious = document.activeElement === previous;
      const focusedNext = document.activeElement === next;
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (atEnd && focusedNext && previous && !previous.disabled) previous.focus({preventScroll:true});
      else if (atStart && focusedPrevious && next && !next.disabled) next.focus({preventScroll:true});
      if (controls) controls.hidden = list.scrollWidth <= list.clientWidth + 2;
    };
    const move = direction => {
      const rtl = getComputedStyle(list).direction === 'rtl';
      list.scrollBy({left:direction * (rtl ? -1 : 1) * list.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    list.addEventListener('scroll', update, {passive:true});
    list.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key) || event.target.closest('input, select, textarea, button, rivo-favorite-button')) return;
      event.preventDefault();
      const rtl = getComputedStyle(list).direction === 'rtl';
      const direction = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
      const control = direction > 0 ? next : previous;
      if (control?.disabled) return;
      control?.focus({preventScroll:true});
      move(direction);
    });
    list.addEventListener('focusin', event => {
      const item = event.target.closest('.native-recently-viewed__item');
      if (item) item.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    else window.addEventListener('resize', update);
    update();
  }

  document.addEventListener('recentlyviewed:visible', event => initialize(event.target));
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.native-recently-viewed').forEach(initialize);
  });
  document.querySelectorAll('.native-recently-viewed').forEach(initialize);
})();
